module.exports = __webpack_public_path__ + "img/register.4360a839.svg";